import { render, staticRenderFns } from "./ShippingAddressList.vue?vue&type=template&id=28ee7aeb&scoped=true&"
import script from "./ShippingAddressList.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee7aeb",
  null
  
)

export default component.exports